import { speedSamples, timeBuckets } from "@/mocks/portal";

export default function SpeedTest() {
  return (
    <section id="speed" className="scroll-mt-20 border-y border-background-200 bg-background-100">
      <div className="mx-auto max-w-[1200px] px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-col gap-1">
          <span className="flex items-center gap-1.5 text-xs font-semibold uppercase tracking-[0.18em] text-accent-600">
            <i className="ri-speed-up-line text-sm" aria-hidden="true" />
            Speed Reference
          </span>
          <h2 className="text-lg font-bold text-foreground-950 md:text-2xl">速度测试参考 · 一周均值</h2>
          <p className="text-xs text-foreground-500 md:text-sm">仅作趋势参考，测速样本会随网络环境变化；数值越小代表延迟越低，越靠右代表带宽余量越高。</p>
        </div>

        <div className="mt-6 grid grid-cols-1 gap-6 lg:grid-cols-[1.4fr_1fr]">
          {/* 条形延迟对比 */}
          <div className="rounded-xl border border-background-200 bg-background-50 p-4 md:p-6">
            <div className="flex items-center justify-between">
              <h3 className="text-sm font-bold text-foreground-950">延迟与带宽样本</h3>
              <span className="font-num whitespace-nowrap text-[11px] text-foreground-500">单位：ms / Mbps</span>
            </div>
            <div className="mt-5 flex flex-col gap-5">
              {speedSamples.map((s) => (
                <div key={s.name}>
                  <div className="flex items-center justify-between text-[13px]">
                    <span className="flex items-center gap-2 font-medium text-foreground-800">
                      <i className="ri-circle-fill text-[7px] text-primary-500" aria-hidden="true" />
                      {s.name}
                    </span>
                    <span className="font-num flex items-center gap-2">
                      <b className="font-bold text-primary-600">{s.latency}ms</b>
                      <span className="text-foreground-400">/</span>
                      <span className="text-foreground-700">{s.bandwidth}M</span>
                      <i className={`${s.delta.startsWith("较上周 -") ? "text-primary-600" : "text-accent-600"} ri-arrow-right-up-line text-[13px]`} aria-hidden="true" />
                    </span>
                  </div>
                  <div className="mt-2 h-2 overflow-hidden rounded-full bg-background-200">
                    <div className="flex h-full rounded-full" style={{ width: `${s.bandwidth}%` }}>
                      <div className="h-full flex-1 bg-gradient-to-r from-primary-300 to-primary-500" />
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <p className="mt-4 text-[11px] leading-5 text-foreground-400">以上为本周汇总样本，实际体验请以客户端内速度测试为准。</p>
          </div>

          {/* 时段参考 */}
          <div className="flex flex-col rounded-xl border border-background-200 bg-background-50 p-4 md:p-6">
            <h3 className="text-sm font-bold text-foreground-950">不同时段的切换参考</h3>
            <p className="mt-1 text-[12px] text-foreground-500">晚高峰选线逻辑会和白天不同，切换指南建议按时段复核。</p>
            <div className="mt-4 flex flex-col gap-3">
              {timeBuckets.map((b, i) => (
                <div key={b.label} className="flex items-start gap-3 rounded-lg bg-background-100 p-3">
                  <span
                    className={`font-num grid h-9 w-9 shrink-0 place-items-center rounded-lg text-xs font-bold ${
                      i === 2 ? "bg-accent-500 text-background-50" : "bg-primary-100 text-primary-700"
                    }`}
                  >
                    {b.label.split(" ")[0]}
                  </span>
                  <div>
                    <p className="font-num text-[13px] font-bold text-foreground-950">{b.label}</p>
                    <p className="mt-0.5 text-[12px] leading-5 text-foreground-600">{b.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}